<template>
    <AppBase>
        <v-card flat height="100%">
            <v-card-title class="justify-center">Settings</v-card-title>
            <v-card-subtitle>Account Information</v-card-subtitle>
            <v-card-text>
                <v-text-field dense :readonly="!editing" flat :label="editing ? `What's the name you go by?` : ``" type="text" v-model="name" @input="name = upperFirst(name)"> </v-text-field>
                <v-text-field dense :readonly="!editing" flat :label="editing ? `What's your cell number?` : ``" type="tel" v-model="phone" v-mask="'(###) ###-####'"> </v-text-field>
                <v-text-field dense :readonly="!editing" flat :label="editing ? `What's your email address?` : ``" type="email" v-model="email"> </v-text-field>
            </v-card-text>
            <v-divider class="mx-4"></v-divider>
            <v-card-subtitle>Notifications</v-card-subtitle>
            <v-card-text>
                <p v-if="!editing">{{ this.notificationLabel }}</p>
                <v-radio-group v-else v-model="notifications">
                    <v-radio v-for="(choice, index) in notificationChoices" :key="index" :label="choice.label" :value="choice.value"></v-radio>
                </v-radio-group>
            </v-card-text>
            <v-card-actions>
                <!-- <v-spacer></v-spacer> -->
                <v-row v-if="!editing" no-gutters justify="center">
                    <v-btn large color="primary" @click="startEditing()">Edit</v-btn>
                </v-row>
                <v-row v-else no-gutters justify="center">
                    <v-col class="d-flex justify-center">
                        <v-btn class="pa-2 justify-center" large outlined color="primary" @click="cancelEdits()">Cancel</v-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col class="d-flex justify-center">
                        <v-btn class="pa-2" large color="primary" :disabled="saveDisabled()" @click="saveEdits()">Save</v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
            <v-card-actions>
                <v-row no-gutters justify="center">
                    <v-btn large color="primary" @click="logout">Logout</v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
    </AppBase>
</template>

<script>
    import AppBase from '@/components/AppBase';
    import { upperFirst, find } from 'lodash';
    import { get } from 'vuex-pathify';
    import isEmail from 'validator/lib/isEmail';

    export default {
        name: 'Settings',
        components: { AppBase },
        data() {
            return {
                editing: false,
                name: null,
                phone: null,
                email: null,
                notifications: null
            };
        },
        computed: {
            storedName: get('name'),
            storedPhone: get('phone'),
            storedEmail: get('email'),
            storedNotifications: get('notifications'),
            notificationChoices: get('content@notificationChoices'),
            notificationLabel() {
                let selectedNotification = find(this.notificationChoices, (o) => {
                    return o.value === this.storedNotifications;
                });

                if (selectedNotification) {
                    return selectedNotification.label;
                } else return null;
            }
        },
        mounted() {
            this.name = this.storedName;
            this.phone = this.storedPhone;
            this.email = this.storedEmail;
            this.notifications = this.storedNotifications;
        },
        methods: {
            upperFirst: upperFirst,
            startEditing() {
                this.editing = true;
            },
            cancelEdits() {
                this.name = this.storedName;
                this.phone = this.storedPhone;
                this.email = this.storedEmail;
                this.notifications = this.storedNotifications;

                this.editing = false;
            },
            saveEdits() {
                this.$store.set('name', this.name);
                this.$store.set('phone', this.phone);
                this.$store.set('email', this.email);
                this.$store.set('notifications', this.notifications);

                this.editing = false;
            },
            saveDisabled() {
                return !this.name || this.name.trim().length === 0 || !this.phone || this.phone.length < 14 || !this.email || !isEmail(this.email);
            },
            logout() {
                this.$api.get('/logout').then(() => {
                    this.$store.commit('resetDefaultState');
                    this.$router.replace({ name: 'home' });
                });
            }
        }
    };
</script>

<style scoped></style>
